import { NumberInput, required, ArrayInput, SimpleFormIterator, minValue, maxValue } from "react-admin";
import { useCallback } from "react";
import { formatDecimal } from "./utils";

const GradeThresholdsArrayInput = () => {
  const minGrade = 2;
  const maxGrade = 6;

  const validateThresholds = useCallback((value, allValues) => {
    const requiredGrades = [minGrade, maxGrade];

    if (!value || value.length === 0) return;

    const maxPoints = allValues.maxPoints;

    const grades = value.map(item => item.grade);
    for (const requiredGrade of requiredGrades) {
      if (!grades.includes(requiredGrade)) {
        return `Оценка ${requiredGrade} е задължителна.`;
      }
    }

    for (let i = 1; i < value.length; i++) {
      if (value[i].minPoints <= value[i - 1].minPoints || value[i].grade <= value[i - 1].grade) {
        return "Минималните точки и оценките трябва да са подредени във възходящ ред.";
      }
    }

    if (value[value.length - 1].minPoints > maxPoints) {
      return "Mинималните точки за отличен не трябва да са повече от максималните точки.";
    }

    if (value[0].minPoints !== 0) {
      return "Минимум точки за оценка 2 трябва да е нулев.";
    }
  }, []);

  return (
    <ArrayInput
      source="gradeThresholds"
      label="Скала"
      validate={validateThresholds}
    >
      <SimpleFormIterator
        inline
        disableClear
        sx={{
          "& .RaSimpleFormIterator-line": {
            padding: 2,
            marginBottom: 3,
          },
        }}
      >
        <NumberInput
          source="minPoints"
          label="Мин. точки"
          validate={required()}
          format={formatDecimal}
          helperText={false}
        />
        <NumberInput
          source="grade"
          label="Оценка"
          helperText={false}
          validate={[required(), minValue(minGrade), maxValue(maxGrade)]}
          format={formatDecimal}
        />
      </SimpleFormIterator>
    </ArrayInput>
  );
};

export default GradeThresholdsArrayInput;
